import {HttpRequest,HttpMethod} from "./http";

class ShopeeProvider extends HttpRequest {
	

	RefreshToken(params) {
        return this.request(HttpMethod.Get,`/api/platform/shopee/refreshtoken`);
    }

	// Tiktok Sync Porduct
	SyncProduct(params) {
		return this.request(HttpMethod.Post,`/api/platform/shopee/products/sync`, params);
	}

	SyncOrder(params) {
		return this.request(HttpMethod.Post,`/api/platform/shopee/orders/sync`, params);
	}

	ConnectPlatform(params) {
		return this.request(HttpMethod.Post,`/api/platform/shopee/connect`, params);
	}

}

export default ShopeeProvider